"use client";

import { Button } from "@ui/button";
import { useRouter, useSearchParams } from "next/navigation";
import { ComponentProps } from "react";
import { isFilterParam } from "../const";
import removeUnwantedQueryParams from "../services/removeUnwantedQueryParams";

export default function ClearFilter({
  children,
  ...props
}: ComponentProps<typeof Button>) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const disabled = [...searchParams].every(([key]) => !isFilterParam(key));

  function handleClick() {
    const newSearchParams = new URLSearchParams(searchParams);
    for (const [key] of [...newSearchParams]) {
      if (isFilterParam(key)) newSearchParams.delete(key);
    }
    router.replace(`?${removeUnwantedQueryParams(newSearchParams).toString()}`);
  }

  return (
    <Button
      onClick={handleClick}
      variant="secondary"
      disabled={disabled}
      {...props}
    >
      {children}
    </Button>
  );
}
